module.exports = __webpack_public_path__ + "media/images/views/lp/icon/shield-icon-4abad0425eadde7c1a033649a778448a.png";